<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="keepAlive" />
    </keep-alive>
    <router-view v-if="!keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      keepAlive: false
    }
  },
  watch: {
    $route: function(to) {
      this.keepAlive = to.meta.keepAlive || false
    }
  },
  mounted() {
    localStorage.setItem('_iosWXConfig_', location.href)
  }
}
</script>

<style lang="less">
.flex-column-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  .middle-box {
    flex: 1;
    overflow: auto;
  }
}
</style>
